import Negotiations from '../Negotiations';
export default Negotiations;
